
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/featured-clients",
      function () {
        return require("private-next-pages/about-us/featured-clients/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/featured-clients"])
      });
    }
  